<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="timer-toggle-header">
      <div class="card__title-block">
        <pdq-heading element="h5">Enable Countdown Timer</pdq-heading>
        <span class="card__subtitle">{{ enableSubtitle }}</span>
      </div>
      <pdq-slide-toggle
        [defaultValue]="formGroup.controls.enabled.value"
        (onToggle)="formGroup.controls.enabled.setValue($event)"></pdq-slide-toggle>
    </div>
  </div>
</pdq-card>

@if (formGroup.controls.enabled.value) {
  <pdq-card variant="popover" color="white">
    <pdq-collapsed class="timer-collapsible" [initialCollapsed]="false">
      <pdq-collapsed-header arrowStyle="chevron" [padding]="'var(--padding-24) var(--padding-16) var(--padding-8)'">
        <pdq-heading element="h5">Configure</pdq-heading>
      </pdq-collapsed-header>
      <pdq-collapsed-content>
        <pdq-divider></pdq-divider>
        <div class="card__content timer-collapsible__body">
          <div class="field">
            <span class="field__label">Timer Duration</span>
            <div class="duration-row">
              <pdq-input-arrows
                class="duration-row__value"
                [formControl]="formGroup.controls.duration.controls.value"
                widthSize="fullwidth"
                [min]="1"
                placeholder="5"></pdq-input-arrows>
              <pdq-dropdown
                class="duration-row__unit"
                [formControl]="formGroup.controls.duration.controls.unit"
                [options]="timerUnitOptions"
                [dirty]="false"></pdq-dropdown>
            </div>
            <span class="field__hint">{{ durationHint }}</span>
          </div>

          <pdq-radio-group [formControl]="formGroup.controls.format" label="Time Format" alignment="vertical">
            <pdq-radio-button value="digital" text="Digital (01:30:45)"></pdq-radio-button>
            <pdq-radio-button value="compact" text="Compact (1Hr 30m)"></pdq-radio-button>
          </pdq-radio-group>

          <pdq-radio-group
            [formControl]="formGroup.controls.placement"
            label="Placement"
            alignment="vertical"
            [preserveTextCase]="true">
            @for (option of placementOptions; track option.value) {
              <pdq-radio-button [value]="option.value" [text]="option.text"></pdq-radio-button>
            }
          </pdq-radio-group>
        </div>
      </pdq-collapsed-content>
    </pdq-collapsed>
  </pdq-card>

  @if (isStyledPlacement) {
    <pdq-card variant="popover" color="white">
      <pdq-collapsed class="timer-collapsible" [initialCollapsed]="false">
        <pdq-collapsed-header arrowStyle="chevron" [padding]="'var(--padding-24) var(--padding-16) var(--padding-8)'">
          <pdq-heading element="h5">Appearance</pdq-heading>
        </pdq-collapsed-header>
        <pdq-collapsed-content>
          <pdq-divider></pdq-divider>
          <div class="card__content timer-collapsible__body">
            <div class="field">
              <div class="message-header">
                <span class="field__label message-header__label">Default Message displayed</span>
                <pdq-button
                  [icon]="previewedState === 'default' ? 'preview_eye' : 'preview_eye_crossed'"
                  variant="ghost"
                  plain="true"
                  size="medium"
                  [iconColor]="previewedState === 'default' ? 'var(--primary-default)' : 'var(--on-surface-light)'"
                  (onClick)="previewTimer('default')"></pdq-button>
              </div>
              <rich-textarea
                [initialContent]="formGroup.controls.defaultMessage.controls.message.value"
                (contentChange)="onTimerMessageChange(formGroup.controls.defaultMessage.controls.message, $event)"
                [enableLinkInsert]="true"
                placeholder="Only {countdown} left to claim this offer!"></rich-textarea>
              <span class="field__hint">Use {{ '{countdown}' }} to dynamically display the time remaining</span>
            </div>
            <div class="field-row">
              <div class="field">
                <span class="field__label">Background Color</span>
                <pdq-input-color
                  [formControl]="formGroup.controls.defaultMessage.controls.backgroundColor"></pdq-input-color>
              </div>
              <div class="field">
                <span class="field__label">Text Color</span>
                <pdq-input-color [formControl]="formGroup.controls.defaultMessage.controls.textColor"></pdq-input-color>
              </div>
            </div>
            <div class="field">
              <span class="field__label">Icon</span>
              <pdq-iconpicker
                [presetIconUrls]="presetIconUrls"
                [iconUrl]="formGroup.controls.defaultMessage.controls.iconUrl.value"
                [customIconUrl]="formGroup.controls.defaultMessage.controls.customIconUrl.value"
                (iconUrlChange)="onTimerIconUrlChange(formGroup.controls.defaultMessage.controls.iconUrl, $event)"
                (uploadCustomRequested)="
                  onTimerUploadCustomIcon(
                    formGroup.controls.defaultMessage.controls.iconUrl,
                    formGroup.controls.defaultMessage.controls.customIconUrl
                  )
                "
                (removeCustomRequested)="
                  onTimerRemoveCustomIcon(
                    formGroup.controls.defaultMessage.controls.iconUrl,
                    formGroup.controls.defaultMessage.controls.customIconUrl
                  )
                "></pdq-iconpicker>
            </div>

            <div class="field">
              <div class="message-header">
                <span class="field__label message-header__label">Message when timer is low</span>
                <pdq-button
                  [icon]="previewedState === 'low' ? 'preview_eye' : 'preview_eye_crossed'"
                  variant="ghost"
                  plain="true"
                  size="medium"
                  [iconColor]="previewedState === 'low' ? 'var(--primary-default)' : 'var(--on-surface-light)'"
                  (onClick)="previewTimer('low')"></pdq-button>
              </div>
              <rich-textarea
                [initialContent]="formGroup.controls.lowTimer.controls.message.value"
                (contentChange)="onTimerMessageChange(formGroup.controls.lowTimer.controls.message, $event)"
                [enableLinkInsert]="true"
                placeholder="Hurry - only {countdown} left!"></rich-textarea>
              <span class="field__hint">Use {{ '{countdown}' }} to dynamically display the time remaining</span>
            </div>
            <div class="field">
              <span class="field__label">Show when Remaining time is under:</span>
              <div class="duration-row">
                <pdq-input-arrows
                  class="duration-row__value"
                  [formControl]="formGroup.controls.lowTimer.controls.threshold.controls.value"
                  widthSize="fullwidth"
                  [min]="1"
                  placeholder="25"></pdq-input-arrows>
                <pdq-dropdown
                  class="duration-row__unit"
                  [formControl]="formGroup.controls.lowTimer.controls.threshold.controls.unit"
                  [options]="timerUnitOptions"
                  [dirty]="false"></pdq-dropdown>
              </div>
            </div>
            <div class="field-row">
              <div class="field">
                <span class="field__label">Background Color</span>
                <pdq-input-color [formControl]="formGroup.controls.lowTimer.controls.backgroundColor"></pdq-input-color>
              </div>
              <div class="field">
                <span class="field__label">Text Color</span>
                <pdq-input-color [formControl]="formGroup.controls.lowTimer.controls.textColor"></pdq-input-color>
              </div>
            </div>
            <div class="field">
              <span class="field__label">Icon</span>
              <pdq-iconpicker
                [presetIconUrls]="presetIconUrls"
                [iconUrl]="formGroup.controls.lowTimer.controls.iconUrl.value"
                [customIconUrl]="formGroup.controls.lowTimer.controls.customIconUrl.value"
                (iconUrlChange)="onTimerIconUrlChange(formGroup.controls.lowTimer.controls.iconUrl, $event)"
                (uploadCustomRequested)="
                  onTimerUploadCustomIcon(
                    formGroup.controls.lowTimer.controls.iconUrl,
                    formGroup.controls.lowTimer.controls.customIconUrl
                  )
                "
                (removeCustomRequested)="
                  onTimerRemoveCustomIcon(
                    formGroup.controls.lowTimer.controls.iconUrl,
                    formGroup.controls.lowTimer.controls.customIconUrl
                  )
                "></pdq-iconpicker>
            </div>

            <pdq-radio-group
              [formControl]="formGroup.controls.expiration.controls.behavior"
              label="Expiration Behavior"
              alignment="vertical">
              <pdq-radio-button value="show_expired_message" text="Show expired message"></pdq-radio-button>
              <pdq-radio-button value="hide_progress_bar" [text]="hideBehaviorLabel"></pdq-radio-button>
            </pdq-radio-group>
            @if (formGroup.controls.expiration.controls.behavior.value === 'show_expired_message') {
              <div class="field">
                <div class="message-header">
                  <span class="field__label message-header__label">Message when time has expired</span>
                  <pdq-button
                    [icon]="previewedState === 'expired' ? 'preview_eye' : 'preview_eye_crossed'"
                    variant="ghost"
                    plain="true"
                    size="medium"
                    [iconColor]="previewedState === 'expired' ? 'var(--primary-default)' : 'var(--on-surface-light)'"
                    (onClick)="previewTimer('expired')"></pdq-button>
                </div>
                <rich-textarea
                  [initialContent]="formGroup.controls.expiration.controls.message.value"
                  (contentChange)="onTimerMessageChange(formGroup.controls.expiration.controls.message, $event)"
                  [enableLinkInsert]="true"
                  placeholder="Offer expired"></rich-textarea>
                <span class="field__hint">Use {{ '{countdown}' }} to dynamically display the time remaining</span>
              </div>
              <div class="field-row">
                <div class="field">
                  <span class="field__label">Background Color</span>
                  <pdq-input-color
                    [formControl]="formGroup.controls.expiration.controls.backgroundColor"></pdq-input-color>
                </div>
                <div class="field">
                  <span class="field__label">Text Color</span>
                  <pdq-input-color [formControl]="formGroup.controls.expiration.controls.textColor"></pdq-input-color>
                </div>
              </div>
              <div class="field">
                <span class="field__label">Icon</span>
                <pdq-iconpicker
                  [presetIconUrls]="presetIconUrls"
                  [iconUrl]="formGroup.controls.expiration.controls.iconUrl.value"
                  [customIconUrl]="formGroup.controls.expiration.controls.customIconUrl.value"
                  (iconUrlChange)="onTimerIconUrlChange(formGroup.controls.expiration.controls.iconUrl, $event)"
                  (uploadCustomRequested)="
                    onTimerUploadCustomIcon(
                      formGroup.controls.expiration.controls.iconUrl,
                      formGroup.controls.expiration.controls.customIconUrl
                    )
                  "
                  (removeCustomRequested)="
                    onTimerRemoveCustomIcon(
                      formGroup.controls.expiration.controls.iconUrl,
                      formGroup.controls.expiration.controls.customIconUrl
                    )
                  "></pdq-iconpicker>
              </div>
            }
          </div>
        </pdq-collapsed-content>
      </pdq-collapsed>
    </pdq-card>
  } @else {
    <pdq-card variant="popover" color="white">
      <pdq-collapsed class="timer-collapsible" [initialCollapsed]="false">
        <pdq-collapsed-header arrowStyle="chevron" [padding]="'var(--padding-24) var(--padding-16) var(--padding-8)'">
          <pdq-heading element="h5">Appearance</pdq-heading>
        </pdq-collapsed-header>
        <pdq-collapsed-content>
          <pdq-divider></pdq-divider>
          <div class="card__content timer-collapsible__body">
            <pdq-radio-group
              [formControl]="formGroup.controls.expiration.controls.behavior"
              label="Expiration Behavior"
              alignment="vertical">
              <pdq-radio-button value="show_expired_message" text="Show expired message"></pdq-radio-button>
              <pdq-radio-button value="hide_progress_bar" [text]="hideBehaviorLabel"></pdq-radio-button>
            </pdq-radio-group>
            <!-- Token placement: the {countdown} in the widget's own text shows 00:00; no styled message. -->
          </div>
        </pdq-collapsed-content>
      </pdq-collapsed>
    </pdq-card>
  }
}
